import {ReactComponent as ChartIcon} from './chart.svg'

function Chart() {
  return <ChartIcon />
}

export default Chart
